<ion-header>
  <ion-toolbar color="primary">
    <!-- Botones -->
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>   
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-row class="ion-no-margin ion-no-padding">

    <ion-col size="12" class="ion-no-margin ion-no-padding">
      <iframe id="iframeWrapper"
      class="iframe"
      frameborder="0" allowfullscreen>
      </iframe>
    </ion-col>

    <ion-col size="12" class="ion-text-center">
      <img class="logo" src="assets/imgs/logo-horizontal.png" alt="Medilabb">
    </ion-col>

  </ion-row>
</ion-content>
